module.exports = __webpack_public_path__ + "img/908887_3C3229_C7C6D0_554A45-256px.b214ebbe.png";